module.exports = __webpack_public_path__ + "img/couples-014.dc7d128e.jpg";